/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Zipcode1Inputs */

const en__field_zipcode1 = /** @type {(inputs: _Field_Zipcode1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ZIP code`)
};

/**
* | output |
* | --- |
* | "ZIP code" |
*
* @param {_Field_Zipcode1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const _field_zipcode1 = /** @type {((inputs?: _Field_Zipcode1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Zipcode1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en__field_zipcode1(inputs)
});
export { _field_zipcode1 as "_field_zipCode" }